module.exports = __webpack_public_path__ + "static/media/1.fb51f80e.png";